import { HIGHLIGHTS } from "@/data/highlights";
import { PageHero } from "@/components/common/PageHero";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { PreviewCard } from "@/components/cards/PreviewCard";
import { CTASection } from "@/components/common/CTASection";
import { IMG } from "@/data/images";

export default function HighlightsIndex() {
  return (
    <>
      <PageHero
        overline="Highlights"
        title="Highlights of the Colosseum & Forum"
        subtitle="Discover the most extraordinary parts of the archaeological park — from the hidden underground to the imperial palaces of Palatine Hill."
        image={IMG.interiorGolden}
        breadcrumbs={[{ label: "Highlights" }]}
      />

      <section className="container-wide py-14 md:py-20">
        <SectionHeading
          overline="The unmissable parts"
          title="Where history comes alive"
          description="Each highlight tells part of the Colosseum's story — and points you to the tickets that get you closest to it."
        />
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {HIGHLIGHTS.map((h, i) => (
            <Reveal key={h.slug} delay={(i % 3) * 0.07}>
              <PreviewCard
                to={`/highlights/${h.slug}`}
                image={h.heroImage}
                title={h.title}
                text={h.subtitle}
                testId={`highlight-card-${h.slug}`}
              />
            </Reveal>
          ))}
        </div>
      </section>

      <div className="container-wide pb-20">
        <CTASection />
      </div>
    </>
  );
}
